export enum ANSI {
  Reset = '\x1b[0m',

  Bold = '\x1b[1m',
  BoldReset = '\x1b[22m',
  Italic = '\x1b[3m',
  ItalicReset = '\x1b[23m',
  Underline = '\x1b[4m',
  UnderlineReset = '\x1b[24m',
  Strike = '\x1b[9m',
  StrikeReset = '\x1b[29m',

  ForegroundReset = '\x1b[0m',
  BackgroundReset = '\x1b[0m',
  ForegroundBlack = '\x1b[30m',
  BackgroundBlack = '\x1b[40m',
  ForegroundRed = '\x1b[31m',
  BackgroundRed = '\x1b[41m',
  ForegroundGreen = '\x1b[32m',
  BackgroundGreen = '\x1b[42m',
  ForegroundYellow = '\x1b[33m',
  BackgroundYellow = '\x1b[43m',
  ForegroundBlue = '\x1b[34m',
  BackgroundBlue = '\x1b[44m',
  ForegroundMagenta = '\x1b[35m',
  BackgroundMagenta = '\x1b[45m',
  ForegroundCyan = '\x1b[36m',
  BackgroundCyan = '\x1b[46m',
  ForegroundWhite = '\x1b[37m',
  BackgroundWhite = '\x1b[47m',
  ForegroundGray = '\x1b[90m',
  ForegroundDefault = '\x1b[39m',
  BackgroundDefault = '\x1b[49m',
}
